import { profileState } from "@/atoms/user/profile-state";
import {
  formatDateToMD,
  formatDateToRemainingDays,
} from "@/common/util/date-util";
import { userService } from "@/services/user-service";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { PartnerHomeDiscountDto } from "@/types/dto/partner-home-discount-dto";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { v4 as uuidv4 } from "uuid";
import { MessageDotOutlineIcon } from "../icon/MessageDotOutlineIcon";
import { Body14Regular } from "../typography/Body14Regular";
import { Footnote12Description } from "../typography/Footnote12Description";
import { H5 } from "../typography/H5";

export const PartnerDiscountSimplePanel = () => {
  const [profile, setProfile] = useRecoilState(profileState);
  const [discounts, setDiscounts] = useState<PartnerHomeDiscountDto>({
    numDiscount: 0,
    numIncentiveDiscount: 0,
    items: [],
  });

  const getPartnerDiscount = async () => {
    try {
      const response = await userService.getPartnerHomeDiscount();
      if (response.ok) {
        setDiscounts(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPartnerDiscount();
  }, []);

  if (!profile) {
    return null;
  }

  const data = [
    {
      id: uuidv4(),
      title: "등급 할인",
      subTitle: profile.grade.name,
      description: `전 제품 ${profile.grade.discountRate}% 기본 할인`,
    },
    {
      id: uuidv4(),
      title: "상품 할인",
      subTitle: `${discounts.numDiscount}건`,
      description: "개별 상품 할인 중",
    },
  ];

  if (discounts.numDiscount !== 0) {
    data.push({
      id: uuidv4(),
      title: "인센티브 할인",
      subTitle: `${discounts.numIncentiveDiscount}건`,
      description: "특별 할인 중",
    });
  }

  return (
    <div className="flex flex-col rounded-[4px] border-[1px] border-semantic-divider bg-primary-white p-[24px] w-[708px] gap-[16px]">
      <div className="flex gap-[16px]">
        {data.map((item) => {
          if (item.title === "인센티브 할인") {
            return <PartnerDiscountSimpleGreenItem key={item.id} item={item} />;
          }
          return <PartnerDiscountSimpleBlackItem key={item.id} item={item} />;
        })}
      </div>
      <PartnerDiscountIncentiveInfo items={discounts.items} />
    </div>
  );
};

interface DataItem {
  id: string;
  title: string;
  subTitle: string;
  description: string;
}

interface PartnerDiscountSimpleItemProps {
  item: DataItem;
}

const PartnerDiscountSimpleBlackItem: React.FC<
  PartnerDiscountSimpleItemProps
> = ({ item }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-[106px] gap-[8px] border-[1px] border-semantic-divider rounded-[4px]">
      <Body14Regular className="text-semantic-text-secondary">
        {item.title}
      </Body14Regular>
      <H5 className="text-semantic-text-body">{item.subTitle}</H5>
      <Footnote12Description className="text-semantic-text-body">
        {item.description}
      </Footnote12Description>
    </div>
  );
};

const PartnerDiscountSimpleGreenItem: React.FC<
  PartnerDiscountSimpleItemProps
> = ({ item }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-[106px] gap-[8px] border-[1px] border-semantic-divider rounded-[4px]">
      <Body14Regular className="text-semantic-text-secondary">
        {item.title}
      </Body14Regular>
      <H5 className="text-secondary-2-green">{item.subTitle}</H5>
      <Footnote12Description className="text-semantic-text-body">
        {item.description}
      </Footnote12Description>
    </div>
  );
};

interface PartnerDiscountIncentiveInfoProps {
  items: ItemDetailDto[];
}

const PartnerDiscountIncentiveInfo: React.FC<
  PartnerDiscountIncentiveInfoProps
> = ({ items }) => {
  // TODO items?지우기
  if (!items || items?.length === 0) {
    return null;
  }

  // if (items.length === 0) {
  //   return null;
  // }

  return (
    <div className="flex flex-col gap-[8px]">
      {items?.map((item) => {
        {
          /* {items.map((item) => { */
        }
        if (!item.incentiveDiscount) {
          return null;
        }

        return (
          <div key={item.id} className="flex justify-between py-[8px]">
            <div className="flex gap-[8px] items-center">
              <MessageDotOutlineIcon
                size={20}
                color="text-grayscale-contrast-40"
              />
              <Body14Regular className="text-semantic-text-body">
                {item.name}
              </Body14Regular>
              <Body14Regular className="text-semantic-text-tertiary">
                {`기간 인센티브 할인 ${item.incentiveDiscount.discountRate}%`}
              </Body14Regular>
            </div>
            <Body14Regular className="text-semantic-text-tertiary">
              할인 {formatDateToRemainingDays(item.incentiveDiscount.endDate)}일
              남음 (~
              {formatDateToMD(item.incentiveDiscount.endDate)}까지)
            </Body14Regular>
          </div>
        );
      })}
    </div>
  );
};
